import React from 'react'
let PropTypes = React.PropTypes
import { AutoSizer, Table, Column } from 'react-virtualized'

import { HeaderConBusqueda } from '../../../components/shared/HeaderConBusqueda.jsx'

import * as css from './TablaOperario.css'
import classNames from 'classnames/bind'
let cx = classNames.bind(css)

export class TablaOperario extends React.Component{
    render() {
        return (
            <div style={{height: '65%'}}>
                <AutoSizer>
                    {({ height, width }) =>
                        <Table
                            height={height}
                            width={width}

                            headerHeight={30}
                            headerClassName={css.headerColumn}

                            rowCount={this.props.operarios.length}
                            rowGetter={({index})=> this.props.operarios[index]}
                            rowHeight={40}
                            rowClassName={({index})=> index<0? css.headerRow : ((index%2===0)? css.evenRow : css.oddRow)}
                        >
                            <Column
                                dataKey='#'
                                label={'#'}
                                disableSort={true}
                                cellRenderer={({rowIndex}) => rowIndex + 1}
                                width={25}
                            />
                            <Column 
                                dataKey='RUN'
                                label={'RUN'}
                                cellRenderer={({rowData, dataKey}) => rowData[dataKey]+'-'+rowData['usuarioDV']}
                                headerRenderer={()=>
                                    <HeaderConBusqueda
                                        nombre="RUN"
                                        busqueda={this.props.busquedaRUN}
                                        realizarBusqueda={this.props.realizarBusquedaRUN}
                                    />
                                }
                                width={80}
                            />
                            <Column
                                dataKey='nombre'
                                label={'Nombre'}
                                cellRenderer={({rowData, dataKey}) => rowData[dataKey]}
                                headerRenderer={()=>
                                    <HeaderConBusqueda
                                        nombre="nombre"
                                        busqueda={this.props.busquedaNombre}
                                        realizarBusqueda={this.props.realizarBusquedaNombre}
                                    />
                                }
                                width={160}
                            />
                            <Column
                                dataKey='comuna'
                                label={'Comuna'}
                                cellRenderer={({rowData, dataKey}) => rowData[dataKey]}
                                headerRenderer={()=>
                                    <HeaderConBusqueda
                                        nombre="comuna"
                                        busqueda={this.props.busquedaComuna}
                                        realizarBusqueda={this.props.realizarBusquedaComuna}
                                    />
                                }
                                width={80}
                            />
                            <Column
                                dataKey='telefono'
                                label={'Teléfono'}
                                cellRenderer={({rowData, dataKey}) => rowData[dataKey]}
                                width={80}
                            />
                            <Column
                                dataKey='unidadesContadas'
                                label={'Conteo'}
                                cellRenderer={({rowData, dataKey}) => rowData[dataKey]}
                                width={60}
                            />
                            <Column
                                dataKey='acciones'
                                label={'Agregar a dotación'}
                                cellRenderer={({ cellData, columnData, dataKey, rowData, rowIndex}) => (
                                    <div className="col-md-12">
                                        <div className="col-md-6">
                                            <button className="btn btn-xs btn-primary" onClick={()=>this.props.agregaOperador(true, rowData['idCaptador'], rowData['RUN'])}>Titular</button>
                                        </div>
                                        <div className="col-md-6">
                                            <button className="btn btn-xs btn-success" onClick={()=>this.props.agregaOperador(false, rowData['idCaptador'], rowData['RUN'])}>Reemplazo</button>
                                        </div>
                                    </div>
                                )}
                                width={200}
                            />
                        </Table>
                    }
                </AutoSizer>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./frontEnd/nominas/nominaIG/components/TablaOperario.jsx